import React from "react";
import { Box, Text } from "@sproutsocial/racine";
import {
  ActionMenu,
  MenuToggleButton,
  MenuContent,
  MenuGroup,
  MenuItem,
} from "@sproutsocial/seeds-react-menu";
import Insights from "assets/logo_small.svg";
import Design from "assets/design-blog.svg";

const ITEMS = [
  {
    url: "https://medium.com/sprout-social-design",
    image: Design,
    title: "Design at Sprout Social",
    subtitle:
      "A collection of stories, ideas, and lessons from Sprout Social’s design and creative teams.",
  },
  {
    url: "https://sproutsocial.com/insights",
    image: Insights,
    title: "Insights",
    subtitle: "Social Media insights and product updates",
  },
];

const BlogDropdown = (props) => {
  return (
    <ActionMenu
      popoutProps={{
        zIndex: 99999,
      }}
      width={"320px"}
      menuToggleElement={
        <MenuToggleButton
          {...props}
          appearance="unstyled"
          css={`
            &:hover {
              text-decoration: underline;
            }
          `}
        >
          <Text fontWeight="normal" fontSize={200} color="neutral.700">
            Blog
          </Text>
        </MenuToggleButton>
      }
    >
      <MenuContent>
        <MenuGroup maxWidth="320px">
          {ITEMS.map((item, i) => (
            <MenuItem
              href={item.url}
              target="_blank"
              key={item.title}
              id={item.title}
            >
              <Box display="flex">
                <img
                  src={item.image}
                  style={{ margin: 0, maxWidth: "30px" }}
                  alt=""
                />

                <Box ml={350}>
                  <Text as="div" fontSize={200} fontWeight="bold">
                    {item.title}
                  </Text>
                  <Text as="div" fontSize={100} color="neutral.600">
                    {item.subtitle}
                  </Text>
                </Box>
              </Box>
            </MenuItem>
          ))}
        </MenuGroup>
      </MenuContent>
    </ActionMenu>
  );
};

export default BlogDropdown;
